export const CORE_ACTION = {
  UPDATE: "CORE_ACTION/UPDATE",
  RESET: "CORE_ACTION/RESET",
  UPDATE_THEME: "CORE_ACTION/UPDATE_THEME",
  UPDATE_DIALOG: "CORE_ACTION/UPDATE_DIALOG",
  CLOSE_DIALOG: "CORE_ACTION/CLOSE_DIALOG",
  ADD_DOWNLOAD_SNACK: "CORE_ACTION/ADD_DOWNLOAD_SNACK",
  REMOVE_DOWNLOAD_SNACK: "CORE_ACTION/REMOVE_DOWNLOAD_SNACK",
  UPDATE_DOWNLOAD_SNACK: "CORE_ACTION/UPDATE_DOWNLOAD_SNACK",
};
